// extracted by mini-css-extract-plugin
module.exports = {"container":"Products_container__kMmGp","product":"Products_product__NErjn","productActive":"Products_productActive__F_YNG"};